"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.collectFeesInstruction = exports.redeemInstruction = exports.settleFundsInstruction = exports.cancelOrderInstruction = exports.createOrderInstruction = exports.depositInstruction = exports.createInstruction = exports.initInstruction = exports.decodeInstruction = exports.Instruction = void 0;
const web3_js_1 = require("@solana/web3.js");
const utils_1 = require("./utils");
const bn_js_1 = require("bn.js");
const bs58_1 = __importDefault(require("bs58"));
var Instruction;
(function (Instruction) {
    Instruction[Instruction["Init"] = 0] = "Init";
    Instruction[Instruction["Create"] = 1] = "Create";
    Instruction[Instruction["Deposit"] = 2] = "Deposit";
    Instruction[Instruction["CreateOrder"] = 3] = "CreateOrder";
    Instruction[Instruction["CancelOrder"] = 4] = "CancelOrder";
    Instruction[Instruction["SettleFunds"] = 5] = "SettleFunds";
    Instruction[Instruction["Redeem"] = 6] = "Redeem";
    Instruction[Instruction["CollectFees"] = 7] = "CollectFees";
})(Instruction = exports.Instruction || (exports.Instruction = {}));
function decodeInstruction(buffer, instructionType) {
    if (buffer[0] !== instructionType) {
        throw 'Incorrect instruction type';
    }
    let offset = 1;
    let poolSeed = buffer.slice(offset, offset + 32);
    offset += 32;
    switch (buffer[0]) {
        case Instruction.Init: {
            let maxNumberOfAssets = new bn_js_1.BN(buffer.slice(offset, offset + 4), 'le').toNumber();
            offset += 4;
            let numberOfMarkets = new bn_js_1.BN(buffer.slice(offset, offset + 2), 'le').toNumber();
            offset += 2;
            return {
                poolSeed: bs58_1.default.encode(poolSeed),
                maxNumberOfAssets,
                numberOfMarkets,
            };
        }
        case Instruction.Create: {
            let numberOfMarkets = new bn_js_1.BN(buffer.slice(offset, offset + 2), 'le').toNumber();
            offset += 2;
            let feeCollectionPeriod = new bn_js_1.BN(buffer.slice(offset, offset + 8), 'le').toNumber();
            offset += 8;
            let feeRatio = new bn_js_1.BN(buffer.slice(offset, offset + 2), 'le').toNumber() / 2 ** 16;
            offset += 2;
            let markets = [];
            for (let i = 0; i < numberOfMarkets; i++) {
                markets.push(new web3_js_1.PublicKey(buffer.slice(offset, offset + 32)));
                offset += 32;
            }
            let depositAmounts = [];
            while (offset < buffer.length) {
                depositAmounts.push(new bn_js_1.BN(buffer.slice(offset, offset + 8), 'le').toNumber());
                offset += 8;
            }
            return {
                poolSeed: bs58_1.default.encode(poolSeed),
                feeCollectionPeriod,
                feeRatio,
                depositAmounts,
                markets,
            };
        }
        case Instruction.Deposit: {
            let poolTokenAmount = new bn_js_1.BN(buffer.slice(offset, offset + 8), 'le').toNumber();
            return {
                poolSeed: bs58_1.default.encode(poolSeed),
                poolTokenAmount,
            };
        }
        case Instruction.CreateOrder: {
            let side = buffer[offset];
            offset++;
            let limitPrice = new bn_js_1.BN(buffer.slice(offset, offset + 8), 'le').toNumber();
            offset += 8;
            let ratioOfPoolAssetsToTrade = new bn_js_1.BN(buffer.slice(offset, offset + 2), 'le').toNumber();
            offset += 2;
            let orderType = buffer[offset];
            offset++;
            let clientId = new bn_js_1.BN(buffer.slice(offset, offset + 8), 'le').toNumber();
            offset += 8;
            let selfTradeBehavior = buffer[offset];
            offset++;
            let sourceIndex = new bn_js_1.BN(buffer.slice(offset, offset + 8), 'le').toNumber();
            offset += 8;
            let targetIndex = new bn_js_1.BN(buffer.slice(offset, offset + 8), 'le').toNumber();
            offset += 8;
            let marketIndex = new bn_js_1.BN(buffer.slice(offset, offset + 2), 'le').toNumber();
            offset += 1;
            let coinLotSize = new bn_js_1.BN(buffer.slice(offset, offset + 8), 'le').toNumber();
            offset += 8;
            let pcLotSize = new bn_js_1.BN(buffer.slice(offset, offset + 8), 'le').toNumber();
            offset += 8;
            let targetMint = new web3_js_1.PublicKey(buffer.slice(offset, offset + 32));
            offset += 32;
            let serumLimit = new bn_js_1.BN(buffer.slice(offset, offset + 2), 'le').toNumber();
            offset += 2;
            return {
                poolSeed: bs58_1.default.encode(poolSeed),
                side,
                limitPrice,
                ratioOfPoolAssetsToTrade,
                orderType,
                clientId,
                selfTradeBehavior,
                sourceIndex,
                targetIndex,
                marketIndex,
                coinLotSize,
                pcLotSize,
                targetMint: targetMint.toBase58(),
                serumLimit,
            };
        }
        case Instruction.CancelOrder: {
            let side = buffer[offset];
            offset++;
            let orderId = Buffer.alloc(16);
            buffer.slice(offset, offset + 16).copy(orderId);
            offset += 16;
            return {
                poolSeed: bs58_1.default.encode(poolSeed),
                side,
                orderId,
            };
        }
        case Instruction.SettleFunds: {
            let pcIndex = new bn_js_1.BN(buffer.slice(offset, offset + 8), 'le').toNumber();
            offset += 8;
            let coinIndex = new bn_js_1.BN(buffer.slice(offset, offset + 8), 'le').toNumber();
            offset += 8;
            return {
                poolSeed: bs58_1.default.encode(poolSeed),
                pcIndex,
                coinIndex,
            };
        }
        case Instruction.Redeem: {
            let poolTokenAmount = new bn_js_1.BN(buffer.slice(offset, offset + 8), 'le').toNumber();
            offset += 8;
            return {
                poolSeed: bs58_1.default.encode(poolSeed),
                poolTokenAmount,
            };
        }
        case Instruction.CollectFees: {
            return {
                poolSeed: bs58_1.default.encode(poolSeed),
            };
        }
    }
    throw 'Failed to parse instruction';
}
exports.decodeInstruction = decodeInstruction;
function initInstruction(splTokenProgramId, systemProgramId, rentProgramId, bonfidaBotProgramId, mintKey, payerKey, poolKey, poolSeed, maxNumberOfAssets, number_of_markets) {
    let buffers = [
        Buffer.from(Int8Array.from([0])),
        Buffer.concat(poolSeed),
        // @ts-ignore
        new utils_1.Numberu32(maxNumberOfAssets).toBuffer(),
        number_of_markets.toBuffer(),
    ];
    const data = Buffer.concat(buffers);
    const keys = [
        {
            pubkey: systemProgramId,
            isSigner: false,
            isWritable: false,
        },
        {
            pubkey: rentProgramId,
            isSigner: false,
            isWritable: false,
        },
        {
            pubkey: splTokenProgramId,
            isSigner: false,
            isWritable: false,
        },
        {
            pubkey: poolKey,
            isSigner: false,
            isWritable: true,
        },
        {
            pubkey: mintKey,
            isSigner: false,
            isWritable: true,
        },
        {
            pubkey: payerKey,
            isSigner: true,
            isWritable: true,
        },
    ];
    return new web3_js_1.TransactionInstruction({
        keys,
        programId: bonfidaBotProgramId,
        data,
    });
}
exports.initInstruction = initInstruction;
function createInstruction(splTokenProgramId, bonfidaBotProgramId, clockSysvarKey, mintKey, poolKey, poolSeed, poolAssetKeys, targetPoolTokenKey, sourceOwnerKey, sourceAssetKeys, serumProgramId, signalProviderKey, depositAmounts, markets, feeCollectionPeriod, feeRatio) {
    let buffers = [
        Buffer.from(Int8Array.from([1])),
        Buffer.concat(poolSeed),
        // @ts-ignore
        new utils_1.Numberu16(markets.length).toBuffer(),
        feeCollectionPeriod.toBuffer(),
        feeRatio.toBuffer(),
    ];
    for (var market of markets) {
        // @ts-ignore
        buffers.push(market.toBuffer());
    }
    for (var amount of depositAmounts) {
        // @ts-ignore
        buffers.push(new utils_1.Numberu64(amount).toBuffer());
    }
    const data = Buffer.concat(buffers);
    const keys = [
        {
            pubkey: splTokenProgramId,
            isSigner: false,
            isWritable: false,
        },
        {
            pubkey: clockSysvarKey,
            isSigner: false,
            isWritable: false,
        },
        {
            pubkey: serumProgramId,
            isSigner: false,
            isWritable: false,
        },
        {
            pubkey: signalProviderKey,
            isSigner: false,
            isWritable: false,
        },
        {
            pubkey: mintKey,
            isSigner: false,
            isWritable: true,
        },
        {
            pubkey: targetPoolTokenKey,
            isSigner: false,
            isWritable: true,
        },
        {
            pubkey: poolKey,
            isSigner: false,
            isWritable: true,
        },
    ];
    for (var poolAsset of poolAssetKeys) {
        keys.push({
            pubkey: poolAsset,
            isSigner: false,
            isWritable: true,
        });
    }
    keys.push({
        pubkey: sourceOwnerKey,
        isSigner: true,
        isWritable: false,
    });
    for (var sourceAsset of sourceAssetKeys) {
        keys.push({
            pubkey: sourceAsset,
            isSigner: false,
            isWritable: true,
        });
    }
    return new web3_js_1.TransactionInstruction({
        keys,
        programId: bonfidaBotProgramId,
        data,
    });
}
exports.createInstruction = createInstruction;
function depositInstruction(splTokenProgramId, bonfidaBotProgramId, sigProviderFeeReceiverKey, bonfidaFeeReceiverKey, bonfidaBuyAndBurnKey, mintKey, poolKey, poolAssetKeys, targetPoolTokenKey, sourceOwnerKey, sourceAssetKeys, poolSeed, poolTokenAmount) {
    let buffers = [
        Buffer.from(Int8Array.from([2])),
        Buffer.concat(poolSeed),
        // @ts-ignore
        poolTokenAmount.toBuffer(),
    ];
    const data = Buffer.concat(buffers);
    const keys = [
        {
            pubkey: splTokenProgramId,
            isSigner: false,
            isWritable: false,
        },
        {
            pubkey: mintKey,
            isSigner: false,
            isWritable: true,
        },
        {
            pubkey: targetPoolTokenKey,
            isSigner: false,
            isWritable: true,
        },
        {
            pubkey: sigProviderFeeReceiverKey,
            isSigner: false,
            isWritable: true,
        },
        {
            pubkey: bonfidaFeeReceiverKey,
            isSigner: false,
            isWritable: true,
        },
        {
            pubkey: bonfidaBuyAndBurnKey,
            isSigner: false,
            isWritable: true,
        },
        {
            pubkey: poolKey,
            isSigner: false,
            isWritable: false,
        },
    ];
    for (var poolAsset of poolAssetKeys) {
        keys.push({
            pubkey: poolAsset,
            isSigner: false,
            isWritable: true,
        });
    }
    keys.push({
        pubkey: sourceOwnerKey,
        isSigner: true,
        isWritable: false,
    });
    for (var sourceAsset of sourceAssetKeys) {
        keys.push({
            pubkey: sourceAsset,
            isSigner: false,
            isWritable: true,
        });
    }
    return new web3_js_1.TransactionInstruction({
        keys,
        programId: bonfidaBotProgramId,
        data,
    });
}
exports.depositInstruction = depositInstruction;
function createOrderInstruction(bonfidaBotProgramId, signalProviderKey, market, payerPoolAssetKey, payerPoolAssetIndex, targetPoolAssetIndex, openOrdersKey, serumRequestQueue, serumEventQueue, serumMarketBids, serumMarketAsks, poolKey, coinVaultKey, pcVaultKey, splTokenProgramId, dexProgramKey, rentProgramId, srmReferrerKey, poolSeed, side, limitPrice, market_index, coin_lot_size, pc_lot_size, target_mint, maxQuantity, orderType, clientId, selfTradeBehavior, serumLimit) {
    let buffers = [
        Buffer.from(Int8Array.from([3])),
        Buffer.concat(poolSeed),
        Buffer.from(Int8Array.from([side])),
        limitPrice.toBuffer(),
        maxQuantity.toBuffer(),
        Buffer.from(Int8Array.from([orderType])),
        clientId.toBuffer(),
        Buffer.from(Int8Array.from([selfTradeBehavior])),
        payerPoolAssetIndex.toBuffer(),
        targetPoolAssetIndex.toBuffer(),
        market_index.toBuffer(),
        coin_lot_size.toBuffer(),
        pc_lot_size.toBuffer(),
        target_mint.toBuffer(),
        serumLimit.toBuffer(),
    ];
    const data = Buffer.concat(buffers);
    const keys = [
        {
            pubkey: signalProviderKey,
            isSigner: true,
            isWritable: false,
        },
        {
            pubkey: market,
            isSigner: false,
            isWritable: true,
        },
        {
            pubkey: payerPoolAssetKey,
            isSigner: false,
            isWritable: true,
        },
        {
            pubkey: openOrdersKey,
            isSigner: false,
            isWritable: true,
        },
        {
            pubkey: serumEventQueue,
            isSigner: false,
            isWritable: true,
        },
        {
            pubkey: serumRequestQueue,
            isSigner: false,
            isWritable: true,
        },
        {
            pubkey: serumMarketBids,
            isSigner: false,
            isWritable: true,
        },
        {
            pubkey: serumMarketAsks,
            isSigner: false,
            isWritable: true,
        },
        {
            pubkey: poolKey,
            isSigner: false,
            isWritable: true,
        },
        {
            pubkey: coinVaultKey,
            isSigner: false,
            isWritable: true,
        },
        {
            pubkey: pcVaultKey,
            isSigner: false,
            isWritable: true,
        },
        {
            pubkey: splTokenProgramId,
            isSigner: false,
            isWritable: false,
        },
        {
            pubkey: rentProgramId,
            isSigner: false,
            isWritable: false,
        },
        {
            pubkey: dexProgramKey,
            isSigner: false,
            isWritable: false,
        },
    ];
    if (!!srmReferrerKey) {
        keys.push({
            pubkey: srmReferrerKey,
            isSigner: false,
            isWritable: true,
        });
    }
    return new web3_js_1.TransactionInstruction({
        keys,
        programId: bonfidaBotProgramId,
        data,
    });
}
exports.createOrderInstruction = createOrderInstruction;
function cancelOrderInstruction(bonfidaBotProgramId, signalProviderKey, market, openOrdersKey, serumEventQueue, serumMarketBids, serumMarketAsks, poolKey, dexProgramKey, poolSeed, side, orderId) {
    let buffers = [
        Buffer.from(Int8Array.from([4])),
        Buffer.concat(poolSeed),
        Buffer.from(Int8Array.from([side])),
        orderId.toBuffer(),
    ];
    const data = Buffer.concat(buffers);
    const keys = [
        {
            pubkey: signalProviderKey,
            isSigner: true,
            isWritable: false,
        },
        {
            pubkey: market,
            isSigner: false,
            isWritable: false,
        },
        {
            pubkey: openOrdersKey,
            isSigner: false,
            isWritable: true,
        },
        {
            pubkey: serumEventQueue,
            isSigner: false,
            isWritable: true,
        },
        {
            pubkey: serumMarketBids,
            isSigner: false,
            isWritable: true,
        },
        {
            pubkey: serumMarketAsks,
            isSigner: false,
            isWritable: true,
        },
        {
            pubkey: poolKey,
            isSigner: false,
            isWritable: false,
        },
        {
            pubkey: dexProgramKey,
            isSigner: false,
            isWritable: false,
        },
    ];
    return new web3_js_1.TransactionInstruction({
        keys,
        programId: bonfidaBotProgramId,
        data,
    });
}
exports.cancelOrderInstruction = cancelOrderInstruction;
function settleFundsInstruction(bonfidaBotProgramId, market, openOrdersKey, poolKey, poolMintKey, coinVaultKey, pcVaultKey, coinPoolAssetKey, pcPoolAssetKey, vaultSignerKey, splTokenProgramId, dexProgramKey, srmReferrerKey, poolSeed, pcPoolAssetIndex, coinPoolAssetIndex) {
    let buffers = [
        Buffer.from(Int8Array.from([5])),
        Buffer.concat(poolSeed),
        pcPoolAssetIndex.toBuffer(),
        coinPoolAssetIndex.toBuffer(),
    ];
    const data = Buffer.concat(buffers);
    const keys = [
        {
            pubkey: market,
            isSigner: false,
            isWritable: true,
        },
        {
            pubkey: openOrdersKey,
            isSigner: false,
            isWritable: true,
        },
        {
            pubkey: poolKey,
            isSigner: false,
            isWritable: true,
        },
        {
            pubkey: poolMintKey,
            isSigner: false,
            isWritable: false,
        },
        {
            pubkey: coinVaultKey,
            isSigner: false,
            isWritable: true,
        },
        {
            pubkey: pcVaultKey,
            isSigner: false,
            isWritable: true,
        },
        {
            pubkey: coinPoolAssetKey,
            isSigner: false,
            isWritable: true,
        },
        {
            pubkey: pcPoolAssetKey,
            isSigner: false,
            isWritable: true,
        },
        {
            pubkey: vaultSignerKey,
            isSigner: false,
            isWritable: false,
        },
        {
            pubkey: splTokenProgramId,
            isSigner: false,
            isWritable: false,
        },
        {
            pubkey: dexProgramKey,
            isSigner: false,
            isWritable: false,
        },
    ];
    if (!!srmReferrerKey) {
        keys.push({
            pubkey: srmReferrerKey,
            isSigner: false,
            isWritable: true,
        });
    }
    return new web3_js_1.TransactionInstruction({
        keys,
        programId: bonfidaBotProgramId,
        data,
    });
}
exports.settleFundsInstruction = settleFundsInstruction;
function redeemInstruction(splTokenProgramId, bonfidaBotProgramId, clockSysvarKey, mintKey, poolKey, poolAssetKeys, sourcePoolTokenOwnerKey, sourcePoolTokenKey, targetAssetKeys, poolSeed, poolTokenAmount) {
    let buffers = [
        Buffer.from(Int8Array.from([6])),
        Buffer.concat(poolSeed),
        // @ts-ignore
        new utils_1.Numberu64(poolTokenAmount).toBuffer(),
    ];
    const data = Buffer.concat(buffers);
    const keys = [
        {
            pubkey: splTokenProgramId,
            isSigner: false,
            isWritable: false,
        },
        {
            pubkey: clockSysvarKey,
            isSigner: false,
            isWritable: false,
        },
        {
            pubkey: mintKey,
            isSigner: false,
            isWritable: true,
        },
        {
            pubkey: sourcePoolTokenOwnerKey,
            isSigner: true,
            isWritable: false,
        },
        {
            pubkey: sourcePoolTokenKey,
            isSigner: false,
            isWritable: true,
        },
        {
            pubkey: poolKey,
            isSigner: false,
            isWritable: true,
        },
    ];
    for (var poolAsset of poolAssetKeys) {
        keys.push({
            pubkey: poolAsset,
            isSigner: false,
            isWritable: true,
        });
    }
    for (var targetAsset of targetAssetKeys) {
        keys.push({
            pubkey: targetAsset,
            isSigner: false,
            isWritable: true,
        });
    }
    return new web3_js_1.TransactionInstruction({
        keys,
        programId: bonfidaBotProgramId,
        data,
    });
}
exports.redeemInstruction = redeemInstruction;
function collectFeesInstruction(splTokenProgramId, clockSysvarKey, bonfidaBotProgramId, poolKey, mintKey, signalProviderPoolTokenKey, bonfidaFeePoolTokenKey, bonfidaBnBPTKey, poolSeed) {
    let buffers = [Buffer.from(Int8Array.from([7])), Buffer.concat(poolSeed)];
    const data = Buffer.concat(buffers);
    const keys = [
        {
            pubkey: splTokenProgramId,
            isSigner: false,
            isWritable: false,
        },
        {
            pubkey: clockSysvarKey,
            isSigner: false,
            isWritable: false,
        },
        {
            pubkey: poolKey,
            isSigner: false,
            isWritable: true,
        },
        {
            pubkey: mintKey,
            isSigner: false,
            isWritable: true,
        },
        {
            pubkey: signalProviderPoolTokenKey,
            isSigner: false,
            isWritable: true,
        },
        {
            pubkey: bonfidaFeePoolTokenKey,
            isSigner: false,
            isWritable: true,
        },
        {
            pubkey: bonfidaBnBPTKey,
            isSigner: false,
            isWritable: true,
        },
    ];
    return new web3_js_1.TransactionInstruction({
        keys,
        programId: bonfidaBotProgramId,
        data,
    });
}
exports.collectFeesInstruction = collectFeesInstruction;
//# sourceMappingURL=instructions.js.map